import { combineReducers } from "redux";

import auth from "./auth/authSlice";
import company from "./company/companySlice";
import calendarReducer from "./calendar/calendarReducer";
import contactReducer from "./contact/contactReducer";
import customiseReducer from "./customise/customiseReducer";
import ecommerceReducer from "./ecommerce/ecommerceReducer";
import stateReducer from "./states/stateSlice";

const rootReducer = combineReducers({
  auth: auth,
  company: company,
  calendar: calendarReducer,
  contact: contactReducer,
  ecommerce: ecommerceReducer,
  customise: customiseReducer,
  states: stateReducer,
});

export default rootReducer;
